import { render } from "./SpaTreatmentTreatments.vue?vue&type=template&id=5ef101f2&scoped=true"
import script from "./SpaTreatmentTreatments.vue?vue&type=script&lang=js"
export * from "./SpaTreatmentTreatments.vue?vue&type=script&lang=js"

import "./SpaTreatmentTreatments.vue?vue&type=style&index=0&id=5ef101f2&scoped=true&lang=css"
import "./SpaTreatmentTreatments.vue?vue&type=style&index=1&id=5ef101f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef101f2"]])

export default __exports__